import PauseInCircleIcon from '@/components/icons/PauseInCircleIcon.vue';
import Play3dIcon from '@/components/icons/Play3dIcon.vue';
import LoadingElement from '@/components/shared/LoadingElement.vue';
import AppModal from "@/components/AppModal";
export default {
  name: "PpcAutomationController",
  props: {
    status: {
      type: [String, null],
      default: "PAUSED"
    },
    ppc_initialized: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    status: {
      handler(newVal, oldVal) {
        if (typeof newVal == "string" && this.ppc_initialized) {
          this.loading = false;
        }
      },
      immediate: true
    },
    ppc_initialized: {
      handler(newval) {
        this.loading = !newval;
      }
    }
  },
  data() {
    return {
      loading: true,
      texts: {
        ENABLED: "Pause budget & bidding automation",
        PAUSED: "Resume budget & bidding automation"
      },
      changeModal: false
    };
  },
  computed: {
    enabled() {
      return this.status === 'ENABLED';
    }
  },
  components: {
    PauseInCircleIcon,
    Play3dIcon,
    LoadingElement,
    AppModal
  },
  methods: {
    handleClick() {
      this.changeModal = true;
    }
  }
};